<template>
  <div>
    <v-row class="pa-sm-5">
      <!-- TODO add real values to progress card when implemented in backend -->
      <!-- TODO uncomment when officially discussed what optimization does -->
      <!-- <v-col :lg="cardSize" xl="3">
        <ProgressCard
            icon="healing"
            iconColor="scaleOrange"
            :title="$t('book/facility:facility.dashboard.progress-card.healthcare-title')"
            progressValue="80"
            btnColor="scaleOrange"
            :btnText="$t('book/facility:facility.dashboard.progress-card.healthcare-btn')"
            @onClick="optimize"
        />
      </v-col> -->
      <v-col  :lg="cardSize" xl="3">
        <ProgressCard
            icon="apartment"
            :title="$t('book/facility:common:facility-info')"
            :progressValue="100"
            :btnText="$t('book/facility:facility.dashboard.progress-card.info-btn')"
            @onClick="$router.push(`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/info/technical`)"
            @clickedCard="$router.push(`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/info/technical`)"
        />
      </v-col>
      <v-col :lg="cardSize" xl="3">
        <ProgressCard
            icon="description"
            :title="$t('common:documentation')"
            :progressValue="docuScore"
            :btnText="$t('buttons:add-specific', { specific: $t('common:documentation')})"
            @onClick="$emit('docuQuickLink')"
            @clickedCard="$router.push(`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/info/documentations`)"
        />
      </v-col>
      <v-col :lg="cardSize" xl="3">
        <ProgressCard
            icon="line_weight"
            :title="$t('common:process_plural')"
            :progressValue="100"
            :btnText="$t('book/facility:facility.dashboard.progress-card.process-btn')"
            @onClick="$emit('processQuickLink')"
            @clickedCard="$router.push(`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/info/processes`)"
        />
      </v-col>
      <v-col :lg="cardSize" xl="3">
        <ProgressCard
            icon="group"
            :title="$t('common:role_plural')"
            :progressValue="roleScore"
            :btnText="$t('buttons:add-specific', { specific: $t('common:role')})"
            @onClick="$emit('roleQuickLink')"
            @clickedCard="$router.push(`/${$store.state.manager.bookModuleUrl}/facilities/edit/${$route.params.id}/info/roles`)"
        />
      </v-col>

      <v-col
          cols="12"
          class="py-2"
      >
        <v-btn-toggle
            v-model="panel"
            tile
            color="deep-purple accent-3"
            group
        >
          <v-btn value="process">
            {{$t('common:process_plural')}}
          </v-btn>

          <v-btn value="task">
            {{$t('common:task_plural')}}
          </v-btn>
        </v-btn-toggle>
      </v-col>
      <!-- Task List -->
      <TaskList
          v-show="panel == 'process'"
          ref="taskList"
          :headerTitle="$t('common:task-list')"
          :headerBtnText="$t('book/facility:common.start-manual-process')"
          @clickedHeaderBtn="$refs.manualProcessForm.openDialog(taskList.options, taskList.search, taskList.filter)"
          @clickedCard="goToTask"
          @updateData="updateTaskList"
          @acceptTask="acceptInvitation($event)"
          @declineTask="declineInvitation($event)"
          @startTask="showGPSPermission($event)"
          :sorts="taskListSorts"
          :filter="taskListFilter"
          :defaultDesc="true"
          defaultSortBy="finishedOn"
          defaultFilterBy="all"
      />

      <FacilityTaskBoard
          v-show="panel == 'task'"
          :facility-id="$route.params.id"
      />

      <TwoButtonDialog
          ref="checkGPSPermission"
          :hide-button="true"
          :dialog-title="$t('common:gps-control')"
          :dialog-text="$t('book/facility:facility.dashboard.gps-dialog')"
          :button1-text="$t('buttons:accept')"
          :button2-text="$t('buttons:decline')"
          @clickedButton1="checkUserLocation($event)"
          @clickedButton2="startProcessJob($event, false)"
      />

      <ProcessResultDialog ref="processResultDialog"/>
      <ProcessShowDialog ref="processShowDialog"/>
      

      <FacilityManualProcessDialogForm
          @updateProcessResults="updateTaskList($event.options, $event.search, $event.filter)"
          ref="manualProcessForm"/>
    </v-row>
  </div>
</template>

<script>

import TaskListService from '@/modules/book/services/process/impl/task-list-service'
import ProcessJobService from '@/modules/book/services/process/impl/process-job-service'
import FacilityService from "@/modules/book/services/facility-service";

import Utils from '@/modules/core/services/utils'
import GPSUtils from '@/modules/core/services/gps-utils';
import DataUtils from '@/modules/core/services/data-utils';

import Facility from '@/modules/book/data/facility';

import ProgressCard from '@/modules/core/components/ProgressCard/ProgressCard';
import ProcessResultDialog from '@/modules/book/components/Process/ProcessResultDialog'
import ProcessShowDialog from '@/modules/book/components/Process/ProcessShowDialog'
import FacilityManualProcessDialogForm from '../formDialogs/FacilityManualProcessDialogForm'
import TaskList from '@/modules/book/components/TaskList/TaskList'
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog';

import {mapState} from 'vuex'
import TaskListUtils from '@/modules/book/services/task-list-utils';
import FacilityTaskBoard from '@/modules/book/views/task/FacilityTaskBoard';

export default {
  name: 'FacilityDashboardTab',
  components: {
    FacilityTaskBoard,
    ProgressCard,
    ProcessResultDialog,
    ProcessShowDialog,
    FacilityManualProcessDialogForm,
    TaskList,
    TwoButtonDialog
  },
  data() {
    return {
      processResults: {
        options: [],
        search: []
      },
      taskList: {
        options: [],
        search: [],
        filter: null,
        period: null
      },
      docuScore: null,
      roleScore: null,
      panel: 'process'
    }
  },
  computed: {
    cardSize() {
      // if both sidebars are fully opened, make card size bigger
      if(this.leftFacilityDrawer && this.rightFacilityDrawer) {
        return '6'
        // if both side bars are closed, make card size smaller
      } else if(!this.leftFacilityDrawer && !this.rightFacilityDrawer) {
        return '2'
      } else {
        return '4'
      }
    },

    taskListSorts() {
      return [
        {label: this.$t('book/facility:facility.dashboard.task-list.sorts.process-name'), value: "processName"},
        {label: this.$t('common:date'), value: "finishedOn"}
      ]
    },

    taskListFilter() {
      return [
        {label: this.$t('common:all'), value: 'all'},
        {label: this.$t('book/facility:common.open-processes'), value: 'open'},
        {label: this.$t('book/facility:facility.dashboard.task-list.filter.finished'), value: 'finishedProcess'}
      ]
    },

    ...mapState('book/layout', {
      leftFacilityDrawer: state => state.leftFacilityDrawer,
      rightFacilityDrawer: state => state.rightFacilityDrawer
    }),
  },
  methods: {

    goToTask(task) {
      // If task is of type result, open result dialog
      if(!task.isJob) {
        this.$refs.processResultDialog.openDialog(task)
      } else {
        this.$refs.processShowDialog.openDialog(task)
      }
    },

    updateTaskList(options, search, filter, period) {
      this.taskList.options = options;
      this.taskList.search = search;
      this.taskList.filter = filter;
      this.taskList.period = period;

      if(filter == 'all') {
        this.readTaskList(options, search, period)
      } else if(filter == 'open') {
        this.readOpenProcess(options, search, period)
      } else if(filter == 'finishedProcess') {
        this.readProcessFinished(options, search, period)
      }
    },

    readTaskList(options, search, period) {
      if(!search) search = '';

      TaskListService.readPageableFacilityTaskListFromAPI(
        this.$route.params.id,
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        period,
        (res) => {

          res.data.taskItems.content.forEach((task) => {
            task.taskStatus = TaskListUtils.getTaskStatus(task);
          })
          this.$refs.taskList.users = res.data.users;
          this.$refs.taskList.fillList(res.data.taskItems)
        },
        (error) => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:task-list')}))
          this.$logger.error(error);
        }
      )
    },

    readOpenProcess(options, search, period) {
      if(!search) search = '';

      TaskListService.readPageableFacilityOpenTaskListFromAPI(
        this.$route.params.id,
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        period,
        (res) => {
          res.data.taskItems.content.forEach((task) => {
            task.taskStatus = TaskListUtils.getTaskStatus(task);
          })
          this.$refs.taskList.users = res.data.users;
          this.$refs.taskList.fillList(res.data.taskItems)
        },
        (error) => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:task-list')}))
          this.$logger.error(error);
        }
      )
    },

    readProcessFinished(options, search, period) {
      if(!search) search = '';

      TaskListService.readPageableFacilityProcessFinishedFromAPI(
        this.$route.params.id,
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        period,
        (res) => {
          res.data.taskItems.content.forEach((task) => {
            task.taskStatus = TaskListUtils.getTaskStatus(task);
          })
          this.$refs.taskList.users = res.data.users;
          this.$refs.taskList.fillList(res.data.taskItems)
        },
        (error) => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:task-list')}))
          this.$logger.error(error);
        }
      )
    },

    startProcessJob(item, gpsCheck) {
      // TODO save users decicion on GPS Check in backend
      if(gpsCheck) {
        this.acceptedGPSCheck = true;
      } else {
        this.acceptedGPSCheck = false;
      }

      ProcessJobService.startProcessJob(item.id, this.acceptedGPSCheck,
        () => {
          this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/process/${item.id}`);
        },
        (error) => {
          this.$logger.info("Error at starting Process Job: " + error);
        }
      )
    },

    showGPSPermission(item) {
      this.$refs.checkGPSPermission.showDialog = true;
      this.$refs.checkGPSPermission.propToGiveThrough = item;
      this.$store.commit("book/process/storeRideCount", null);
      this.$store.commit("book/process/storeFileNumber", null);
    },

    checkUserLocation(item) {
      FacilityService.readFromAPI(item.facility,
        (resp) => {
          var response = DataUtils.parseDataToSingleObject(resp.data, Facility);
          var buildingLat = response.buildingLatitude;
          var buildingLng = response.buildingLongitude;

          this.$getLocation({
            enableHighAccuracy: true,
          }).then(coordinates => {
              var userLat = coordinates.lat;
              var userLng = coordinates.lng;

              var distance = GPSUtils.calcDistance(userLat, userLng, buildingLat, buildingLng);
              if(distance == -1){
                Utils.showFailureSnackbar(this.$t('utils:gps.missing-value'))
              }
              if(distance < process.env.VUE_APP_CHECK_IN_LOCATION_RADIUS) {
                this.startProcessJob(item, true);
              } else {
                this.$refs.checkGPSPermission.showDialog = false;
                Utils.showFailureSnackbar(this.$t('utils:gps.distance-error'))
              }
          }).catch((error) => {
            this.$logger.info("Could not access GPS data, because: " + error);
            Utils.showFailureSnackbar(this.$t('utils:gps.access-error'))
          });
        }
      )
    },

    acceptInvitation(item) {
      if(item.isJob) {
        ProcessJobService.acceptProcessJob(item.id,
          () => {
            this.updateTaskList(this.taskList.options, this.taskList.search, this.taskList.filter, this.taskList.period);
            Utils.showSuccessSnackbar(this.$t('book/facility:facility.dashboard.task-list.snackbar.accept-process'));
          },
          (error) => {
            this.$logger.info("Error at accepting Process Job: " + error);
          }
        )
      }
    },

    declineInvitation(item) {
      if(item.isJob) {
        ProcessJobService.rejectProcessJob(item.id,
          () => {
            this.updateTaskList(this.taskList.options, this.taskList.search, this.taskList.filter, this.taskList.period);
            Utils.showSuccessSnackbar(this.$t('book/facility:facility.dashboard.task-list.snackbar.reject-process'));
          },
          (error) => {
            this.$logger.info("Error at rejecting Process Job: " + error);
          }
        )
      }
    }
  }
}
</script>